import React, { useEffect } from "react";
import { withStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import TextField from "../../../../../../../ui/TextField";
import DataSelect from "../../../../../../../ui/DataSelect";
import useConnectForm from "./useConnectForm";

const initialData = {
  isId: null,
  programId: null,
  typeId: null,
  dateBegin: null,
  dateEnd: null
};

const styles = () => ({
    root: {
        "& .MuiFormLabel-root": {
            whiteSpace: "nowrap"
        }
    },
});

const AddConnectForm = ({ disabled, onFormChange, classes }) => {
    const [data, setData] = React.useState(initialData);
    const {
        dataSources,
        getQuizTypesList,
        getProgramsList,
        getIsList
    } = useConnectForm();
    const {
      isId,
      programId,
      typeId,
      dateBegin,
      dateEnd
    } = data;

    useEffect(() => {
      /*getQuizTypesList(),
      getProgramsList(),
      getIsList()*/
    }, []);

    const onChange = (field, value) => {
        const newState = {
            ...data,
            [field]: value
        };

        setData(newState);
        onFormChange(newState);
    };

    return (
        <div className={classes.root}>
          <DataSelect
              value={isId}
              onChange={value => onChange("isId", value.id)}
              label="Информационная система"
              dataSource={dataSources.isList}
              disabled={disabled}
          />
          <DataSelect
              value={programId}
              onChange={value => onChange("programId", value.id)}
              label="Программа/Модуль"
              dataSource={dataSources.programsList}
              disabled={disabled}
          />
            <Grid container spacing={2}>
                <Grid item xs={4}>
                    <DataSelect
                        value={typeId}
                        onChange={value => onChange("typeId", value.id)}
                        label="Тип"
                        dataSource={dataSources.quizTypes}
                        disabled={disabled}
                    />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                      value={dateBegin}
                      onChange={e => onChange("dateBegin", e.target.value)}
                      label="Начало"
                      disabled={disabled}
                  />
                </Grid>
                <Grid item xs={4}>
                  <TextField
                      value={dateEnd}
                      onChange={e => onChange("dateEnd", e.target.value)}
                      label="Окончание"
                      disabled={disabled}
                  />
                </Grid>
            </Grid>
        </div>
    );
};

export default withStyles(styles)(AddConnectForm);
